// 코스메틱 도메인 카탈로그 — 확률 고지·서버 계약·card_key 파싱의 단일 출처.

export type Grade = 'N' | 'R' | 'E' | 'L';

export const GRADES: Grade[] = ['N', 'R', 'E', 'L'];

/** 가챠 풀 캐릭터 순서 — RPC _cosmetic_cast_slug·cast.jsx CAST 정의 순서와 1:1 */
export const CHAR_ORDER = [
  'kkami', 'bbiyong', 'ryan', 'kongi', 'roki', 'tobi', 'lumi', 'mio', 'yeouni', 'hwangdoongi', 'bugi',
] as const;

/** 등급별 법정 고지 메타 — 확률은 gachaEngine과 정합해야 한다. */
export const GRADE_META: Record<Grade, { label: string; ratePct: number; eachPct: string }> = {
  N: { label: '일반', ratePct: 50, eachPct: '4.545' },
  R: { label: '레어', ratePct: 35, eachPct: '3.182' },
  E: { label: '에픽', ratePct: 12, eachPct: '1.091' },
  L: { label: '전설', ratePct: 3, eachPct: '0.273' },
};

/** 배치 슬롯 7종 라벨 (§14-2) — 서버 SLOT_KEYS·cosmetic_equips CHECK와 1:1 */
export const SLOT_LABELS: Record<string, string> = {
  nick_avatar: '닉 옆 아바타',
  home_mascot: '홈 마스코트',
  profile_character: '프로필 캐릭터',
  coach_avatar: '코치 아바타',
  onboarding_hero: '첫 10연 히어로 연출',
  empty_state: '빈 화면 캐릭터',
  loading_sprite: '로딩 스프라이트',
  finance_hero: '투자 자아 카드',
};

/** 사용자가 지속 장착하는 슬롯만. onboarding_hero는 첫 10연 직후 1회 연출 전용이라 제외한다. */
export const EQUIPPABLE_SLOT_LABELS: Record<string, string> = Object.fromEntries(
  Object.entries(SLOT_LABELS).filter(([key]) => key !== 'onboarding_hero'),
);

/** 시그니처 배지 14종 라벨 (§15-2) — badge_key는 서버 BADGE_KEYS·signature_badges CHECK와 1:1 */
export const BADGE_LABELS: Record<string, { label: string; emoji: string }> = {
  money_mbti: { label: '머니타입 풀 진단', emoji: '🧭' },
  asset_timemachine: { label: '자산 타임머신', emoji: '⏳' },
  time_value: { label: '시간가치 환산기', emoji: '⚖️' },
  life_event_sim: { label: '인생 이벤트 시뮬', emoji: '🛤' },
  asset_health: { label: '자산↔건강 상관', emoji: '💪' },
  bull_challenge: { label: 'BULL 달성 챌린지', emoji: '🎯' },
  regret_lock_24h: { label: '24시 후회방지 락', emoji: '🔒' },
  buy_or_not_vote: { label: '살까 말까 투표', emoji: '🗳' },
  sunk_cost_coach: { label: '매몰비용 코치', emoji: '🪙' },
  confirmation_bias: { label: '확증편향 검사', emoji: '🔍' },
  future_self_talk: { label: '미래 자아 대화', emoji: '💬' },
  self_control_score: { label: '자기통제 점수', emoji: '🧊' },
  emotion_spend_diary: { label: '감정·소비 일기', emoji: '📓' },
  rate_alert: { label: '금리 알림', emoji: '🔔' },
};

/** card_key '<grade>:<slug>' 파싱 — 이상값은 null */
export function parseCardKey(cardKey: string): { grade: Grade; slug: string } | null {
  const [grade, slug] = String(cardKey || '').split(':');
  if (!grade || !slug || !GRADES.includes(grade as Grade)) return null;
  return { grade: grade as Grade, slug };
}

/** cb 포맷 — 3자리 콤마 */
export function fmtCb(n: number): string {
  return (Number(n) || 0).toLocaleString('ko-KR');
}
